/**
 * @public
 */
export enum COMMUNITY_ACTIVITY {
  ONGOING = 'ongoing',
  COMING_SOON = 'coming_soon',
  ACTIVE = 'active',
  TO_REDISCOVER = 'to_rediscover',
  INACTIVE = 'inactive',
}

/**
 * @public
 */
export enum COMMUNITY_LIFETIME {
  RETREAT = 'retreat',
  NOVENA = 'novena',
  EVERLASTING = 'everlasting',
}

/**
 * @public
 */
export enum COMMUNITY_PUBLICATION_FREQUENCY {
  SPORADICALLY = 'sporadically',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

/**
 * @public
 */
export enum COMMUNITY_FORMAT {
  TEXTUAL = 'textual',
  AUDIO = 'audio',
  VIDEO = 'video',
}

/**
 * @public
 */
export enum COMMUNITY_STATUS {
  DRAFT = 'draft',
  CHECK = 'check',
  // TODO: check if we can delete these statuses
  VALID = 'valid', // unused
}

/**
 * @public
 */
export enum COMMUNITY_DISPLAYMODE {
  TO_REWORK = 'to_rework',
  UNTREATED = 'untreated',
  DISPLAYED = 'displayed',
  HIDDEN = 'hidden',
  FAVORITE = 'favorite',
}

/**
 * @public
 */
export enum COMMUNITY_ROLE {
  MEMBER = 'member',
  ANIMATOR = 'animator',
  ADMINISTRATOR = 'administrator',
  CREATOR = 'creator',
}

export enum COMMUNITY_ORDER {
  PUBLICATIONS = 'publications',
  ACTIVITY = 'activity',
  POPULARITY = 'popularity',
  FRESHNESS = 'freshness',
  ACTIVITY_AND_FAVORITE = 'order-activity-and-favorite',
  WEIGHT_THEN_FAVORITE = 'order-weight-then-favorite',
}

export enum COMMUNITY_FILTER {
  TAG = 'tag',
  DISPLAY_ALL = 'displayAll',
  KEYWORD = 'keyword',
  INDEXED = 'indexed',
  // WEIGHT_AND_FAVORITE = 'weightAndFavorite', unused
  FROM_WIZARD_ANSWERS = 'fromWizardAnswers',
  ID = 'id',
}

export enum EVENT_ORIGIN {
  AUTOMATIC = 'automatic-join', // from an automatic subscription through query parameters (ads/optimize)
  COMMUNITIES_SUGGESTION = 'communities-suggestion', // from the communities list page with user wizard settings matching
  COMMUNITY_PUBLICATIONS_TAB = 'community-publications-tab', // from the publications tab of a community page
  PUBLICATION_PRAYED_CONGRATS = 'publication-prayed-congrats', // back to the community page after praying a publication
  COMMUNITY_SHARE = 'community-share', // from a shared link to the community page
  PUBLICATION_SHARE = 'publication-share', // from a shared link to a publication
  PUBLICATION = 'publication', // from a shared link to a publication
  PUBLICATION_REWARD = 'publication-reward', // from a publication prayed reward screen
  SUGGESTED_SECTION = 'suggested-section', // from the communities page suggested section
  SUGGESTED_PAGE = 'suggested-page', // from the suggested communities page
  CURRENTLY_SECTION = 'currently-section', // from the communities currently section
  CURRENTLY_PAGE = 'currently-page', // from the communities currently page
  TEAM_FAVORITES_SECTION = 'team-favorites-section', // from the communities page team favorites section
  TEAM_FAVORITES_PAGE = 'team-favorites-page', // from the team favorites page
  TAG_SECTION = 'tag-section', // from the communities page tag section
  TAG_PAGE = 'tag-page', // from the tag page
  COMMUNITIES_SEARCH = 'communities-search', // from the communities page search
  PROFILE_ANIMATOR = 'profile-animator', // from the animator tab of a user's profile page
  PROFILE_MEMBER = 'profile-member', // from the member tab of a user's profile page
  SUBSCRIPTION_CARD = 'subscription-card', // from the subscription card in prayer space
  UNDEFINED = 'undefined',
}

export enum COMMUNITIES_CATEGORY {
  SUGGESTED = 'suggested-for-you',
  CURRENTLY = 'currently',
  TEAM_FAVORITES = 'team-favorites',
  TAG = 'tag',
}
